import { App, Plugin } from "@pimo/pimo-app-builder";

import type { HomePortalAppState } from "../app";
import { ResetPasswordPage } from "../components/reset-password-page";
import { APP_ROUTES } from "../constants";
import { requestPasswordReset } from "../helpers/fetch-registration";

export class ResetPasswordPlugin implements Plugin<HomePortalAppState> {
  private app?: App<HomePortalAppState>;

  onRegister(app: App<HomePortalAppState>): void {
    this.app = app;

    const view = app.createView({ name: "ResetPassword" });

    const resetPasswordComponent = view.addComponent({
      component: ResetPasswordPage,
    });

    resetPasswordComponent.mapState((state) => ({
      language: state.language,
    }));

    resetPasswordComponent.on("back-to-login", () => {
      this.app?.navigate(APP_ROUTES.home);
    });

    resetPasswordComponent.on("change-language", ({ payload }) => {
      if (!payload?.language) return;
      app.patchAppState({ language: payload.language });
    });

    resetPasswordComponent.on("request-password-reset", ({ payload }) => {
      const email = (payload as { email?: string } | undefined)?.email;
      if (email) {
        void requestPasswordReset(email);
      }
    });

    app.createRoute({
      path: APP_ROUTES.resetPassword,
      view,
      isOverlayChild: false,
    });
  }
}
